import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on, Action } from '@ngrx/store';

import { PaginatedLanguageList } from '@offconon/core-api';

import * as LanguageDropdownActions from './language-dropdown.actions';
import { LanguageDropdownEntity } from './language-dropdown.models';

export const LANGUAGE_DROPDOWN_FEATURE_KEY = 'languageDropdown';

export interface LanguageDropdownState extends EntityState<LanguageDropdownEntity> {
  languageResponse: { [key: string]: PaginatedLanguageList };
}

export interface LanguageDropdownPartialState {
  readonly [LANGUAGE_DROPDOWN_FEATURE_KEY]: LanguageDropdownState;
}

export const languageDropdownAdapter: EntityAdapter<LanguageDropdownEntity> =
  createEntityAdapter<LanguageDropdownEntity>();

export const initialLanguageDropdownState: LanguageDropdownState =
  languageDropdownAdapter.getInitialState({
    languageResponse: {
      '': {
        results: [],
        page_size: 0,
        total_pages: 0,
        current_page_number: 0,
      },
    },
  });

const reducer = createReducer(
  initialLanguageDropdownState,
  on(LanguageDropdownActions.initLanguageDropdown, (state) => ({
    ...state,
  })),

  on(
    LanguageDropdownActions.fetchLanguagesSuccess,
    (state, { languageResponse, dropdownId = '' }) => {
      const currentState = state.languageResponse[dropdownId || ''] || { results: [] };
      const uniqueLanguages = Array.from(
        new Map(
          [...(currentState['results'] || []), ...(languageResponse['results'] || [])].map(
            (lang) => [lang.id, lang],
          ),
        ).values(),
      );
      const sortedLanguages = uniqueLanguages.sort((a, b) => {
        if (typeof a.id === 'number' && typeof b.id === 'number') {
          return a.id - b.id;
        }

        return String(a.id).localeCompare(String(b.id), undefined, {
          numeric: true,
        });
      });

      return {
        ...state,
        languageResponse: {
          ...state.languageResponse,
          [dropdownId || '']: {
            total_objects: languageResponse['total_objects'],
            results: sortedLanguages,
            page_size: languageResponse['page_size'],
            current_page_number: languageResponse['current_page_number'],
          },
        },
      };
    },
  ),
);

export function languageDropdownReducer(state: LanguageDropdownState | undefined, action: Action) {
  return reducer(state, action);
}
